import { render } from "./ProfileCourseToolbarSubpage.vue?vue&type=template&id=6bb78f00&scoped=true"
import script from "./ProfileCourseToolbarSubpage.vue?vue&type=script&lang=js"
export * from "./ProfileCourseToolbarSubpage.vue?vue&type=script&lang=js"

import "./ProfileCourseToolbarSubpage.vue?vue&type=style&index=0&id=6bb78f00&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bb78f00"]])

export default __exports__